<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  beforeMount() {
    // let that = this;

    // that
    //   .$axios("/api/swimming/logintest", {}, "post")
    //   .then((res) => {
    //     if (res) {
    //       console.log(res);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(`获取失败：${error.message}`);
    //   });
  },
  mounted() {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue